import api from '@/api'

export default {
  state: () => ({
    addresses: []
  }),
  getters: {
    addresses(state) {
      return state.addresses
    }
  },
  mutations: {
    setAddress(state, payload) {
      state.addresses = payload
    }
  },
  actions: {
    async getAddresses({ commit }) {
      try {
        const { data, success } = await api.address.addresses() || {}
        if (success) {
          commit('setAddress', data.records)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
